import { api } from './index';

const BannerRequestService = {
    save(params){
        return api.post('banner',params);
    },
    delete (index) {
        return api.delete('banner/'+index);
    },
    change_position(old_index, new_index) {
        return api.post(`banner-change-position/${old_index}/${new_index}`);
    },
    get_list () {
        return api.get('banner-list');
    },
    edit_info (index, params) {
        return api.put('banner-edit-info/'+index,{...params});
    },
};

export default BannerRequestService;